const faceImgList = [
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_1.png',
        title: '微笑',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_2.png',
        title: '大笑',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_3.png',
        title: '坏笑',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_4.png',
        title: '可爱',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_5.png',
        title: '爱心',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_6.png',
        title: '鬼脸',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_7.png',
        title: '亲亲',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_8.png',
        title: '思考',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_9.png',
        title: '发怒',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_10.png',
        title: '雷到了',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_11.png',
        title: '闭嘴',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_12.png',
        title: '不高兴',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_13.png',
        title: '哭泣',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_14.png',
        title: '吃惊',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_15.png',
        title: '冷汗',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_16.png',
        title: '发呆',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_17.png',
        title: '咒骂',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_18.png',
        title: '尴尬',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_19.png',
        title: '呕吐',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_20.png',
        title: '拜拜',
    },
];

const newFaceImgList = [
    {
        class: 'zhoumei',
        title: '皱眉',
        name: 'frown',
    },
    {
        class: 'sese',
        title: '色色',
        name: 'lechery',
    },
    {
        class: 'kuqi',
        title: '哭泣',
        name: 'cry',
    },
    {
        class: 'ciya',
        title: '龇牙',
        name: 'teethlaugh',
    },
    {
        class: 'jing',
        title: '惊',
        name: 'amaze',
    },
    {
        class: 'yun',
        title: '晕',
        name: 'dizzy',
    },
    {
        class: 'qinqin',
        title: '亲亲',
        name: 'kiss',
    },
    {
        class: 'aoman',
        title: '傲慢',
        name: 'arrogant',
    },
    {
        class: 'huanhu',
        title: '欢呼',
        name: 'cheer',
    },
    {
        class: 'keai',
        title: '可爱',
        name: 'cute',
    },
    {
        class: 'haixiu',
        title: '害羞',
        name: 'shy',
    },
    {
        class: 'wulianku',
        title: '捂脸哭',
        name: 'facepalmcry',
    },
    {
        class: 'shengqi',
        title: '生气',
        name: 'angry',
    },
    {
        class: 'kun',
        title: '困',
        name: 'sleepy',
    },
    {
        class: 'guanzhu',
        title: '求关注',
        name: 'follow',
    },
    {
        class: 'yiwen',
        title: '疑问',
        name: 'doubt',
    },
    {
        class: 'liuhan',
        title: '流汗',
        name: 'sweat',
    },
    {
        class: 'kelian',
        title: '可怜',
        name: 'pathetic',
    },
    {
        class: 'hanxiao',
        title: '憨笑',
        name: 'defaultemoji',
    },
    {
        class: 'outu',
        title: '呕吐',
        name: 'vomit',
    },
    {
        class: 'xiaoku',
        title: '笑哭',
        name: 'laughcry',
    },
    {
        class: 'touxiao',
        title: '偷笑',
        name: 'titter',
    },
    {
        class: 'jianxiao',
        title: '奸笑',
        name: 'comic',
    },
    {
        class: 'zhuakuang',
        title: '抓狂',
        name: 'crazy',
    },
    {
        class: 'shuizhao',
        title: '睡着',
        name: 'sleep',
    },
    {
        class: 'cuoe',
        title: '错愕',
        name: 'astonished',
    },
    {
        class: 'daku',
        title: '大哭',
        name: 'bigcry',
    },
    {
        class: 'leng',
        title: '愣',
        name: 'daze',
    },
    {
        class: 'fendou',
        title: '奋斗',
        name: 'struggle',
    },
    {
        class: 'angel',
        title: '天使',
        name: 'angel',
    },
    {
        class: 'bye',
        title: '拜拜',
        name: 'bye',
    },
    {
        class: 'shuai',
        title: '衰',
        name: 'wane',
    },
    {
        class: 'ganga',
        title: '尴尬',
        name: 'awkward',
    },
    {
        class: 'bizui',
        title: '闭嘴',
        name: 'shutup',
    },
    {
        class: 'sick',
        title: '生病',
        name: 'fallill',
    },
    {
        class: 'love',
        title: '爱心',
        name: 'heart',
    },
    {
        class: 'rose',
        title: '玫瑰',
        name: 'rose',
    },
    {
        class: 'guzhang',
        title: '鼓掌',
        name: 'applause',
    },
    {
        class: 'dianzan',
        title: '点赞',
        name: 'praise',
    },
    {
        class: 'guapi',
        title: '西瓜',
        name: 'watermelon',
    },
];

export { faceImgList, newFaceImgList };
